import React from 'react';

import { Icon } from 'rsuite';

import './cardsStyles.css';


export default function CardsPainel({ colorCard, number, HeaderBadge, icon, description, }) {
  let colorBoxCard = 'boxCardGreem';
  let colorNumber = 'numberForCardGreem';
  let badgeColor = 'badgeCardGreem';
  if (colorCard === 'red') {
    colorBoxCard = 'boxCardRed';
    colorNumber = 'numberForCardRed';
    badgeColor = 'badgeCardRed';
  } else if (colorCard === 'yellow') {
    colorBoxCard ='boxCardYelow';
    colorNumber ='numberForCardYelow';
    badgeColor ='badgeCardYelow';
  }


  return (
    <div className={colorBoxCard}>
      <div className="BoxInternoCard">
        <div className={badgeColor}>
          <Icon
            className="IconBadge"
            icon={icon}
          />
          <p className="TitleBadge">
            {HeaderBadge}
          </p>
        </div>
        <div className="DetailsIntern">
          <span className={colorNumber}>
            {number ? number : '0'}
          </span>
          <p className="descriptionCard">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}
